export default RAILS_ASSET_URL("/before-after-engine-bay-before.webp")
